import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';
import Image from '@base/Image';
import { getRegularDate } from '@utils/dates';
import { FREE_TRIAL_DAYS } from '@constants/index';

const GoalCardWrapper = styled.div`
  border: 1px solid var(--color-divider);
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_4B};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Info = styled.div`
  max-width: 80%;
`;

const Title = styled(H5)``;

const GoalDescription = styled(P2)``;

const Duration = styled(P2)`
  color: var(--color-text-secondary);
`;

const GoalIcon = styled.div`
  width: 52px;
  height: 52px;
  position: relative;
`;

const GoalCard = ({ name, icon, endDate }) => {
  return (
    <GoalCardWrapper>
      <Info>
        <Title>{name}</Title>
        <GoalDescription>{FREE_TRIAL_DAYS}-day free trial</GoalDescription>
        {endDate && (
          <Duration>{`Valid till ${getRegularDate(endDate)}`}</Duration>
        )}
      </Info>
      <GoalIcon>
        <Image layout="fill" src={icon} alt="-" />
      </GoalIcon>
    </GoalCardWrapper>
  );
};

export default GoalCard;
